<script setup>
// Lo que el taller hace además de fabricar.
//
// Es el escalón de gamuza del amanecer, el sexto tono, que existe por esta
// sección: nació compartiendo el café de Telas y no se leía como una sección
// aparte, que es justo lo que es.
//
// Sin foto y sin ficha, a diferencia de las cortinas y las telas. Una
// instalación no se elige mirándola: se lee qué incluye y se pregunta.
//
// Lo que sí hay es un dibujo, y es lo primero de cada tarjeta: cuatro párrafos
// seguidos se leen de arriba abajo, cuatro dibujos se distinguen de un vistazo.
// El botón es uno solo al final de la sección y no uno por servicio.
import { services } from '@/data/catalog'
import ServiceIcon from '@/components/ServiceIcon.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'

defineProps({
  phone: { type: String, required: true }
})
</script>

<template>
  <section v-if="services.length" id="servicios" class="bg-suede scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 lg:px-10">
      <div class="py-16 lg:py-24">
        <header class="max-w-2xl">
          <h2 class="display text-[clamp(1.9rem,4vw,3rem)] text-linen">Servicios</h2>
          <p class="mt-3 leading-relaxed text-linen/70">
            No solo fabricamos: también vamos a tu casa por la cortina que ya tienes.
          </p>
        </header>

        <ul class="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:mt-12 lg:grid-cols-4">
          <li
            v-for="service in services"
            :key="service.name"
            class="border-t border-linen/15 pt-5"
          >
            <ServiceIcon :name="service.icon" class="h-7 w-7 text-glow" />
            <h3 class="display mt-3 text-xl text-linen sm:text-2xl">{{ service.name }}</h3>
            <p class="mt-1.5 leading-relaxed text-linen/70">{{ service.description }}</p>
          </li>
        </ul>

        <!-- Un servicio no se cotiza con las medidas de una ventana, así que
             acá no va el formulario: va la conversación. -->
        <div class="mt-12 flex flex-wrap items-center gap-x-5 gap-y-4 text-linen">
          <WhatsappButton
            :phone="phone"
            variant="outline"
            subject="un servicio para mis cortinas"
            label="Consultar por WhatsApp"
            source="services"
          />
          <p class="text-linen/70">Cuéntanos qué necesitas y lo coordinamos.</p>
        </div>
      </div>
    </div>
  </section>
</template>
